import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AgricolaService } from '../../../../services/agricola.service';
import { MeService } from '../../../../services/me.service';
import { AccountRow } from '../agricola-policy-detail.component';

export interface UpdatePaymentDialogData {
  managementCode:      string;
  insuredName:         string;
  accountRows:         AccountRow[];
  currentAccount:      AccountRow | null;
  assistanceSaleId:    number;
  frontingId:          number;
  memberId:            number;
  planName:            string;
  assistanceSaleCode:  string;
}

@Component({
  selector: 'app-agricola-update-payment-dialog',
  templateUrl: './agricola-update-payment-dialog.component.html',
  styleUrls: ['./agricola-update-payment-dialog.component.css'],
  standalone: false
})
export class AgricolaUpdatePaymentDialogComponent implements OnInit {

  form!: FormGroup;
  isSubmitting = false;

  agencyOptions:  { value: string; label: string }[] = [];
  accountOptions: { value: string; label: string }[] = [];
  selectedAccount: AccountRow | null = null;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AgricolaUpdatePaymentDialogComponent>,
    private agricolaService: AgricolaService,
    private meService: MeService,
    @Inject(MAT_DIALOG_DATA) public data: UpdatePaymentDialogData
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      managementCode:      [{ value: this.data.managementCode ?? '', disabled: true }],
      selectedAccountCode: [null, Validators.required],
      agencyCode:          [null]
    });

    this.accountOptions = (this.data.accountRows ?? [])
      .filter(a => a.accountNumber !== this.data.currentAccount?.accountNumber)
      .map(a => ({
        value: a.accountNumber,
        label: `${a.accountNumber} — ${a.accountType}`
      }));

    this.form.get('selectedAccountCode')!.valueChanges.subscribe(val => {
      this.selectedAccount = this.data.accountRows.find(a => a.accountNumber === val) ?? null;
    });

    this.loadAgencies();
  }

  private loadAgencies(): void {
    this.agricolaService.getAgencies().subscribe({
      next: (res: any) => {
        const raw = res?.data?.data ?? res?.data ?? res;
        const rows: any[] = Array.isArray(raw) ? raw : [];
        this.agencyOptions = rows
          .filter(r => r?.code)
          .map(r => ({
            value: String(r.code),
            label: String(r.description_es || r.description_en || r.code)
          }));
      }
    });
  }

  onSubmit(): void {
    if (this.form.invalid) return;
    const f = this.form.getRawValue();
    const today = new Date().toISOString().split('T')[0];

    const payload = {
      country_id:           4,
      sponsor_id:           'ESR98',
      fronting_id:          this.data.frontingId,
      username:             this.meService.currentUser?.email ?? '',
      userId:               this.meService.currentUser?.id   ?? '',
      guid:                 '',
      ucontact_did:         '',
      account_id:           this.data.memberId,
      transaction:          'assistance_payment_method_change',
      transaction_type:     'CPC',
      transaction_date:     today,
      typology_id:          null,
      subtypology_id:       null,
      assistance_code:      this.data.assistanceSaleId,
      assistance_sale_code: this.data.assistanceSaleCode,
      current_account:      this.data.currentAccount?.accountNumber ?? '',
      new_account:          this.selectedAccount?.accountNumber      ?? '',
      new_account_type:     this.selectedAccount?.accountType        ?? '',
      UidViciDial:          '',
      agency_id:            f.agencyCode || '',
      agency_name:          this.agencyOptions.find(a => a.value === f.agencyCode)?.label || '',
      agency_user:          this.meService.currentUser?.name || this.meService.currentUser?.email || '',
      agency_user_id:       null,
      elapsedTime:          0,
      plan:                 this.data.planName
    };

    this.isSubmitting = true;
    this.agricolaService.chubbTransaction(payload).subscribe({
      next: () => { this.isSubmitting = false; this.dialogRef.close({ success: true }); },
      error: () => { this.isSubmitting = false; this.dialogRef.close({ success: false }); }
    });
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
